/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
export default Number.isInteger || function _isInteger(n) {
  return n << 0 === n;
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_isInteger.js
// module id = ../node_modules/ramda/es/internal/_isInteger.js
// module chunks = 5